import {
  SET_WISHLIST_UID,
  SET_WISHLIST_ENTRIES,
  DELETE_WISHLIST_ENTRY,
  NOTIFY_PRODUCT,
  SET_WISHLIST_ENTRIES_LOADING,
  UNSET_WISHLIST_ENTRIES_LOADING,
} from '@/account/context/wishlist/types';

export const setWishlistUid = payload => ({ type: SET_WISHLIST_UID, payload });
export const setWishlistEntries = payload => ({
  type: SET_WISHLIST_ENTRIES,
  payload,
});
export const setWishlistEntriesLoading = () => ({
  type: SET_WISHLIST_ENTRIES_LOADING,
});
export const unsetWishlistEntriesLoading = () => ({
  type: UNSET_WISHLIST_ENTRIES_LOADING,
});
export const deleteWishlistEntry = payload => ({
  type: DELETE_WISHLIST_ENTRY,
  payload,
});
export const notifyProduct = payload => ({
  type: NOTIFY_PRODUCT,
  payload,
});
